module.exports = __webpack_public_path__ + "img/home_img_15.3924d5ea.png";